import { GoogleMap, Marker, useJsApiLoader, InfoWindow } from '@react-google-maps/api';
import React, { useCallback, useEffect, useState } from 'react';
import moment from 'moment/moment';
import { useParams } from 'react-router-dom';

import NotificationsAlert from '../../../../services/NotificationsAlert.jsx';
import pin from "../../../../assets/marker.png";
import Conect from '../../../../../Api/Conect.js';

// eslint-disable-next-line
import '../../../css/style.css';

const Acompanhamento = () => {
    const { id } = useParams();

    // const [idVehicle, setIdVehicle] = useState()
    const [positions, setPositions] = useState([])
    const [centerPositions, setCenterPositions] = useState({ lat: -31.72978671059568, lng: -52.343938513840065, zoom: 13 })
    const [selectedPosition, setSelectedPosition] = useState(null)
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyChY0qKEv0A5uZX5eoibw0aSZbbs3zxfnM"
    })

    const getPositions = useCallback(async () => {

        const response = await Conect.post(`/lastposivehicle`, {
            id: id
        })
        // eslint-disable-next-line
        if (response.data.erro === true) {
            NotificationsAlert("warning", "Atenção", response.data.msg)
        }
        else {
            let data = response.data.positionsVehicles
            if (response.data.positionsVehicles != null) {
                var dados = data.map((value, index) => {
                    setCenterPositions({ lat: value.latitude, lng: value.longitude, zoom: 18 })
                    return (<Marker
                        key={index}
                        position={{ lat: value.latitude, lng: value.longitude }}
                        onClick={() => {
                            setSelectedPosition(value)
                        }}
                        options={{
                            label: {
                                text: `${value.plate}`,
                                className: "map-marker"
                            }
                        }}
                        icon={{
                            url: pin,
                            scaledSize: new window.google.maps.Size(35, 35)
                        }}
                    />)
                })
            }
            // eslint-disable-next-line
            setPositions(dados)
        }
        // eslint-disable-next-line
    }, [])

    const fetchData = useCallback(async () => {
        await getPositions();

        const interval = setInterval(getPositions, 15000);
        return () => clearInterval(interval);
    }, [getPositions]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <>
            <div style={{ width: "100%", height: "100vh" }}>
                {isLoaded && (
                    <GoogleMap
                        mapContainerStyle={{ width: '100%', height: "100%" }}
                        center={{ lat: centerPositions.lat, lng: centerPositions.lng }}
                        zoom={centerPositions.zoom}
                    >
                        {positions != null && positions}

                        {selectedPosition && (
                            <InfoWindow
                                position={{
                                    lat: selectedPosition.latitude,
                                    lng: selectedPosition.longitude
                                }}
                                onCloseClick={() => {
                                    setCenterPositions({ lat: selectedPosition.latitude, lng: selectedPosition.longitude, zoom: 18 })
                                    setSelectedPosition(null)
                                }}

                            >
                                <div>
                                    <h3>{selectedPosition.plate}</h3>
                                    <h5 style={{ fontStyle: 'oblique' }}>{`${selectedPosition.description}`}</h5>
                                    <p>{`Velocidade: ${selectedPosition.speed.toFixed(2)}Km/h`}</p>
                                    <p>{`Ignição: ${selectedPosition.ignition === 0 ? 'Desligada': 'Ligada' }`}</p>
                                    <p>{`Dia: ${moment(selectedPosition.dateTime).subtract(3, "hours").format("DD/MM/yyyy")} Hora: ${moment(selectedPosition.dateTime).subtract(3, "hours").format("HH:mm:ss")}`}</p>
                                </div>
                            </InfoWindow>
                        )}
                    </GoogleMap>
                )}
            </div>
        </>
    )
}

export default Acompanhamento;